import 'css-chunksrc/client/scenes/comments/loader/styles.scss';export default {
  "feed": "_feed_1qe6k_1",
  "comment": "_comment_1qe6k_8",
  "ownComment": "_ownComment_1qe6k_15"
};